import { DATE_FILTER_CHANGE, SCANBACK_CHANGE } from 'containers/Dashboard/Home/constants'
import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from 'containers/PartnerOptions/constants'

import { createAsyncTypes } from './ActionCreator'

const initialStateX = {
  data: [],
  loader: false,
  error: null,
}

export const createDashboardReduxModule = ({ name, path, initialState = initialStateX }) => {
  const REQUEST_TYPE = createAsyncTypes(`${name.toUpperCase()}_REQUEST_ASYNC`, `IronScales/${path}`)

  const reducer = (state = initialState, action) => {
    switch (action.type) {
      case REQUEST_TYPE.INITIATE:
      case DATE_FILTER_CHANGE:
      case SCANBACK_CHANGE:
      case FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS:
        return { ...state, loader: true }
      case REQUEST_TYPE.SUCCESS: {
        return {
          ...state,
          data: action.payload,
          error: null,
          loader: false,
        }
      }
      case REQUEST_TYPE.ERROR:
        return { ...state, error: action.error, loader: false }
      case REQUEST_TYPE.CANCEL:
        return { ...state, loader: false }
      default:
        return state
    }
  }

  const parts = path.split('/')
  const selectors = {
    selectData: (state) => parts.reduce((acc, part) => acc?.[part], state)?.data,
    selectLoader: (state) => parts.reduce((acc, part) => acc?.[part], state)?.loader,
    selectError: (state) => parts.reduce((acc, part) => acc?.[part], state)?.error,
  }

  return {
    ...REQUEST_TYPE,
    reducer,
    selectors,
  }
}
